import React from 'react'
import { Typography } from 'antd'
import { stepsParams } from '../constants'

const StepFragment = ({ label, content, inProgress }) => (
  <div>
    <Typography.Text {...stepsParams.stepText(inProgress)(true)}>{label}:</Typography.Text>
    <Typography.Text {...stepsParams.stepText(inProgress)(false)}>{` ${content}`}</Typography.Text>
  </div>
)

export default StepFragment
